export const creatingRoadmapPool: string[] = [
    "I’m building an actionable roadmap—think of me as your GPS!",
    "Hold on while I craft your roadmap—no traffic jams allowed!",
    "Just a moment; I’m drafting your roadmap to success!",
    "I’m piecing together an actionable roadmap—buckle up!",
    "Hang tight; your roadmap is being built—road signs included!",
    "I’m laying out your roadmap—no detours in sight!",
    "Give me a sec; your actionable roadmap is almost ready!",
    "I’m mapping your journey—this roadmap will lead to treasure!",
    "Just a moment; I’m designing your roadmap—no wrong turns!",
    "I’m constructing your actionable roadmap—let’s hit the road!"
];

export const creatingRoadmapWorkingPhrases: string[] = [
    "Breaking down the project draft into actionable steps...",
    "Identifying key milestones for the roadmap...",
    "Organizing tasks by priority and sequence...",
    "Aligning tasks with project objectives...",
    "Ensuring all deliverables are accounted for...",
    "Structuring tasks into a logical flow...",
    "Allocating resources to each action item...",
    "Reviewing the roadmap for consistency and accuracy...",
    "Finalizing the roadmap with actionable tasks and timelines..."
];

export const creatingProjectDraftPool: string[] = [
    "I’m crafting your project draft—hard hats not required!",
    "Hold tight! Your project draft is cooking like a five-star meal!",
    "Just a moment while I whip up your project draft—no magic wand needed!",
    "I’m brewing your project draft—no taste tests until it's done!",
    "Hang tight; your project draft will be more polished than my last haircut!",
    "I’m assembling your project draft—think of me as a mechanic!",
    "Give me a sec while I put together your project draft—no assembly required!",
    "I’m fine-tuning your project draft—like a DJ mixing tracks!",
    "Just a moment; your project draft will be smoother than my karaoke!",
    "I’m building your project draft—less likely to wash away than a sandcastle!"
];

export const creatingProjectDraftWorkingPhrases: string[] = [
    "Gathering your project inputs...",
    "Analyzing your ideas for clarity...",
    "Structuring the project details...",
    "Compiling essential information...",
    "Creating a framework for your project...",
    "Defining key objectives and outcomes...",
    "Assessing feasibility and scope...",
    "Organizing details into a coherent draft...",
    "Drafting the project outline...",
    "Finalizing the project details for your review..."
]